var React = require('react');

function Left (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Icon/Glyph/16px/ic_chevron-left"),React.createElement("path",{"d":"M6.933 1.513L2.447 6l4.486 4.487a.667.667 0 0 1 0 .946.667.667 0 0 1-.946 0l-4.894-4.9a.753.753 0 0 1 0-1.066L6 .567a.667.667 0 0 1 .947 0 .667.667 0 0 1-.014.946z","fill":"#FFF","fillRule":"nonzero","key":1})]);
}

Left.defaultProps = {"width":"8","height":"12","viewBox":"0 0 8 12"};

module.exports = Left;

Left.default = Left;
